<template>
 <main class="dn-margin-1">
    <div id="homePage">

      <ProductCard
        v-for="product in products"
        :key="product.id"
        :title="product.title"
        :image="product.image"
        @click="openPage(product.id)"
      />

    </div>
  </main>
</template>

<script>
import ProductCard from './ProductCard.vue'
import { getProductsByCategory } from '@/config/products'

export default {
  name: 'Home',
  components: {
    ProductCard
  },
  data () {
    return {
      products: []
    }
  },
  created() {
    // const type = this.$route.query.type || 'washing'
    this.products = getProductsByCategory('washing')
  },
  methods: {
    openPage: function (page) {
      let qdParam = this.$route.query.qd || this.$route.query.q || ''
      this.$parent.$router.push('/xxxz?toPage=' + page + '&qd=' + qdParam)
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Home.vue